import { ApiDataSource } from '@core/api/api.data-source';
import { debounceTime, finalize, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CustomerExperienceMainCategoriesService } from './customer-experience-main-categories.service';
import { CustomerExperienceMainCategory } from './customer-experience-main-categories.model';
import { SystemUserService } from '../system-user/system-user.service';

export class CustomerExperienceMainCategoriesDataSource extends ApiDataSource<CustomerExperienceMainCategory> {

    public isOpenedNewTab = false;

    public $status = of([
        { key: true, value: this.translate.instant('GENERAL.ACTIVE') },
        { key: false, value: this.translate.instant('GENERAL.PASSIVE') }
    ]);

    public $users = this.mainCategoriesService.listCreatedUsers({ filter: {} }).pipe(
        map(response => response.data),
        map(users => users.map(item => {
            return {
                key: item.userId,
                value: item.displayName
            };
        }))
    );

    public filterReq: any = {};

    getFilter() {
        return this.filterReq;
    }

    constructor(
        private mainCategoriesService: CustomerExperienceMainCategoriesService,
        private translate: TranslateService,
        protected initialFilter?: any,
    ) {
        super(initialFilter);
    }

    load(): void {
        if (!this.isOpenedNewTab) {

            // Init filter with data source's default filter
            const filterValue: any = { ...this.initialFilter, ...this.filter };

            // If filter keyword exists, filter data
            if (this.keyword) {
                filterValue.searchText = this.keyword;
            }

            // Update loading state
            this.loadingSubject.next(true);

            // Create request parameters
            const request = this.getRequest();
            if (!request.orderType) {
                request.orderType = 'ASC';
                request.orderBy = 'orderBy';
            }

            if (this.paginator?.pageSize) {
                request.pageSize = this.paginator.pageSize;
            }

            // Add filters to request
            request.filter = filterValue;

            this.filterReq = { ...request };

            // Fetch data
            this.mainCategoriesService
                .search(request)
                .pipe(
                    debounceTime(400),
                    finalize(() => this.loadingSubject.next(false))
                ).subscribe(response => {
                    // Update count and data subjects
                    this.dataSubject.next(response.data.results);
                    this.dataCountSubject.next(response.data.rowCount);

                    // Update data source's empty based row count
                    this.empty = response.data.rowCount === 0;
                });

        }
        return this.loadingSubject.next(false);
    }

}
